module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/123.4c60edda.png";